// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2247
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import {
  RulesetResult,
  IsExpressLoan,
  IsBetweenMidAugMidOct,
  IsBetweenMidOctMidNov,
  IsForProfit,
} from '../rules';
import IsBusinessEstablishedLessThan from '../rules/IsBusinessEstablishedLessThan';

class FinancialStatementQ2Ruleset implements Ruleset {
  private forProfitResult = (
    data: Partial<ApplicationFormValues>
  ): RulesetResult => {
    const isBetweenMidAugAndMidNov = [
      IsBetweenMidAugMidOct,
      IsBetweenMidOctMidNov,
    ].some((Is) => Is.evaluate(data));

    const establishedLessThanThreeYearsAgo =
      IsBusinessEstablishedLessThan.setYears(3).evaluate(data);

    if (isBetweenMidAugAndMidNov) {
      // A) Between Mid Aug and Mid Nov && Not Express Loan (Core, Express Plus, Industry PG or PPA)
      if (!IsExpressLoan.evaluate(data)) {
        return RulesetResult.REQUIRED;
        // B) Between Mid Aug and Mid Nov && Express Loan && Established Less Than Three Years Ago
      } else if (
        IsExpressLoan.evaluate(data) &&
        establishedLessThanThreeYearsAgo
      ) {
        return RulesetResult.REQUIRED;
      }
    }
    return RulesetResult.HIDDEN;
  };

  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isForProfit = IsForProfit.evaluate(data);

    // If For Profit
    if (isForProfit) return this.forProfitResult(data);

    // If Not For Profit

    const isBetweenMidAugAndMidOct = IsBetweenMidAugMidOct.evaluate(data);

    if (isBetweenMidAugAndMidOct) {
      return RulesetResult.REQUIRED;
    }
    return RulesetResult.HIDDEN;
  };
}

export default new FinancialStatementQ2Ruleset();
